<svg
    class="object-scale-down h-48 w-full"
    width="354"
    height="333"
    viewBox="0 0 354 333"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
>
    <path
        d="M105.396 282.625L69.7334 175.777L195.399 208.568L200.122 330.763L105.396 282.625Z"
        fill="#F2B13E"
    />
    <path
        d="M71.0914 177.046L194.537 209.255L199.189 329.3L106.102 282.008L71.0738 177.046L71.0914 177.046ZM68.3779 174.526L104.658 283.259L201.057 332.225L196.229 207.881L68.3779 174.526Z"
        fill="#F2B13E"
    />
    <path
        d="M228.738 138.229L83.6543 173.082L196.299 201.75L334.757 152.326L228.738 138.229Z"
        fill="#4E1C07"
    />
    <path
        d="M228.737 138.229L244.912 251.791L319.551 244.514L334.757 152.326L228.737 138.229Z"
        fill="#190F08"
    />
    <path
        d="M197.215 208.41L352.465 153.277L325.577 251.931L201.884 330.658L197.215 208.41Z"
        fill="#F2B13E"
    />
    <path
        d="M351.179 154.669L324.819 251.367L202.712 329.089L198.114 209.027L351.179 154.669ZM353.769 151.885L196.316 207.811L201.074 332.226L326.352 252.495L353.769 151.885Z"
        fill="#F2B13E"
    />
    <path
        d="M186.485 312.508L110.824 276.123L88.6934 190.313L182.731 216.603L186.485 312.508Z"
        fill="#190F08"
    />
    <path
        d="M319.55 244.513L214.517 309.848L210.535 215.599L340.324 166.95L319.55 244.513Z"
        fill="#4E1C07"
    />
    <path
        d="M72.0225 174.544L233.898 135.657L350.119 152.255L196.279 206.895L72.0401 174.562L72.0225 174.544ZM79.9867 173.064L196.349 202.666L338.473 151.938L228.682 137.348L79.9867 173.064Z"
        fill="#F2B13E"
    />
    <path
        d="M233.934 136.556L294.335 145.172L232.348 136.926L233.934 136.538L233.934 136.556ZM341.257 151.867L346.438 152.607L196.227 205.961L75.653 174.58L79.1065 173.751L83.2296 174.791L195.874 203.441L196.403 203.582L196.914 203.406L335.355 153.982L341.275 151.867L341.257 151.867ZM233.863 134.758L68.4111 174.509L196.333 207.811L353.785 151.885L233.863 134.758ZM196.333 201.732L83.6877 173.082L228.771 138.229L334.791 152.325L196.35 201.75L196.333 201.732Z"
        fill="#F2B13E"
    />
    <path
        d="M221.249 134.758L69.1709 166.95L33.0322 4.36963L196.299 8.17556L221.249 134.758Z"
        fill="#4E1C07"
    />
    <path
        d="M229.212 135.886C200.139 139.798 179.066 114.09 173.075 82.0747C166.185 45.2488 176.07 21.9375 196.316 8.17627L229.212 135.886Z"
        fill="#190F08"
    />
    <path
        d="M40.3096 22.0779L185.111 20.9326"
        stroke="#1F1209"
        stroke-miterlimit="10"
    />
    <path
        d="M174.115 43.874L47.374 50.6577"
        stroke="#1F1209"
        stroke-linejoin="bevel"
    />
    <path
        d="M54.5811 80.8936L171.807 72.0308"
        stroke="#1F1209"
        stroke-miterlimit="10"
    />
    <path
        d="M177.85 98.8657L62.4561 113.86"
        stroke="#1F1209"
        stroke-miterlimit="10"
    />
    <path
        d="M69.1709 142.035L191.947 120.169"
        stroke="#1F1209"
        stroke-miterlimit="10"
    />
    <path
        d="M199.753 1.4977L27.6758 0L68.3957 174.526L233.848 134.758L199.753 1.4977ZM37.2435 8.19331L196.299 8.19331L225.425 127.551L74.0517 162.58L37.2435 8.19331Z"
        fill="#F2B13E"
    />
    <path
        d="M68.395 174.526C32.8377 181.381 7.69396 140.185 1.45647 91.7827C-4.79865 43.3629 10.055 11.2416 27.6751 -7.14277e-09L68.395 174.526Z"
        fill="#F2B13E"
    />
    <path
        d="M288.839 215.017L276.752 220.532L276.752 179.09L297.614 171.831L288.839 215.017Z"
        fill="#F2B13E"
    />
    <path
        d="M59.6734 159.532C33.032 157.206 17.7202 130.564 12.6984 100.135C7.201 66.8857 10.3197 36.914 27.6755 20.9326L59.6911 159.532L59.6734 159.532Z"
        fill="#190F08"
    />
</svg>
